import { actionConst } from '../constants/warranty.constants'
import { requestsConstants } from '../containers/Requests/requests.constants'
import addressActions from './address.actions'
import { authHeader, authUploadHeader, authHeaderForm } from '../helpers/auth-header'
import { client } from './'
import moment from 'moment';
import { requestsActions } from '../containers/Requests/requests.actions'
import { fromDateStr } from '../helpers/utcDate';

const url = '/Request';

const actions = {
	openWarrantyModal,
	closeWarrantyModal,
	openWarrantyInfoModal,
	closeWarrantyInfoModal,
	postWarrantyInfo,
	postWarrantyState,
	fetchFileTypesList,
	setPossWarranty,
	resetWarrantySetResult,
};

function fetchFileTypesList() {

	let rurl = '/warranty/doc_types';

	return dispatch => {
		dispatch({
			type: actionConst.FETCH_FILETYPES_REF,
			payload: client.get(rurl, { headers: authHeader() })
		})
	}
}

function resetWarrantySetResult() {
	return dispatch => {
		dispatch({
			type: actionConst.HIDE_WARRANTY_STATE_OK,
		})
	}
}

function postWarrantyInfo(v) {

	let rurl = '/warranty/info/' + v.requestId;

	return dispatch => {
		client.put(rurl, v, { headers: authHeader() })
			.then((response) => {
				console.log(response);

				dispatch({
					type: actionConst.POST_WARRANTY_INFO_OK,
					payload: v.requestId,
				})

			})
			.catch(function (error) {
				console.log(error);
				dispatch({
					type: requestsConstants.POST_ERROR,
					payload: error
				})
			});
	}
}

function setPossWarranty(rid, data, addressData = null) {
	let rurl = '/warranty/set_warranty/' + rid;

	return (dispatch, getState) => {

		client.put(rurl, data, { headers: authHeader() })
			.then((response) => {

				if (addressData) {
					dispatch(addressActions.postAddress(addressData));
				} else {
					const rl = getState().requestsStore.requests.slice();
					const ri = rl.findIndex(el => el.id == rid);
					rl[ri].garantyId = data;
			
					dispatch({
						type: requestsConstants.SET_REQUEST_STATUS,
						payload: new Promise(resolve=>{resolve({data: rl})}),
					})
				}
			})
			.catch(function (error) {
				console.log(error);
				dispatch({
					type: requestsConstants.POST_ERROR,
					payload: error
				})
			});
	}
}

function putState(reqn, data, ns) {

	let rurl = '/warranty/set_state/' + reqn;

	return (dispatch, getState) => {

		client.put(rurl, data, { headers: authHeaderForm() })
			.then((response) => {
				console.log(response);

				dispatch({
					type: actionConst.SHOW_WARRANTY_STATE_OK,
					payload: { reqn, ns }
				})

				const rl = getState().requestsStore.requests.slice();
				const ri = rl.findIndex(el => el.id == reqn);
				console.log(ri)
				console.log(rl[ri])

				const nsi = parseInt(ns);
				rl[ri].garantyId = nsi 
				rl[ri].garanty = nsi == 1
				console.log(rl[ri])

				dispatch({
					type: requestsConstants.SET_REQUEST_STATUS,
					payload: new Promise(resolve=>{resolve({data: rl})}),
				})



			})
			.catch(function (error) {
				console.log(error);
				dispatch({
					type: requestsConstants.POST_ERROR,
					payload: error
				})
			});
	}
}

function postWarrantyState(value, attachments) {
	return (dispatch, getState) => {

		const nr = value.request;

		if (nr && attachments.length === 1) {		
				new Promise((resolve, reject) => {
				const formData = new FormData();				
				formData.append('file', attachments[0]);
				formData.append('name', value.name);
				formData.append('typeId', value.type);
				formData.append('newState', value.newState);
				formData.append('docDate', fromDateStr(value.docDate));
				dispatch(putState(nr, formData, value.newState));				
				resolve()
			}).then(() => {
				//dispatch(requestsActions.fetchRequests(nr));		
			}).catch(err => {
				console.log(err);
			})
		}
		else if(nr) {
			new Promise((resolve, reject) => {
				const formData = new FormData();				
				formData.append('newState', value.newState);
				dispatch(putState(nr, formData, value.newState));				
				resolve()
			}).then(() => {
				//dispatch(requestsActions.fetchRequests(nr));
			}).catch(err=>{
				console.log(err);
			})
		}
	}
}

function openWarrantyModal(r,v) {
	return dispatch => {
		dispatch({
			type: actionConst.OPEN_WARRANTY_MODAL,
			payload: v,
			id: r
		})
	}
}

function closeWarrantyModal() {
	return dispatch => {
		dispatch({
			type: actionConst.CLOSE_WARRANTY_MODAL
		})
	}
}

function openWarrantyInfoModal(r,i) {
	return dispatch => {
		dispatch({
			type: actionConst.OPEN_WARRANTY_INFO_MODAL,
			payload: {r,i},
		})
	}
}

function closeWarrantyInfoModal() {
	return dispatch => {
		dispatch({
			type: actionConst.CLOSE_WARRANTY_INFO_MODAL
		})
	}
}


export default actions;